import { ReactNode } from 'react';

export type StatusTone = 'online' | 'offline' | 'warning' | 'busy' | 'idle';

export interface StatusIndicatorProps {
  tone?: StatusTone;
  label?: ReactNode;
  /** Pulsująca kropka - dla aktywnych stanów (np. "na żywo"). */
  pulse?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

const TONE_MAP: Record<StatusTone, { bg: string; ring: string }> = {
  online:  { bg: 'bg-success',  ring: 'bg-success/40' },
  offline: { bg: 'bg-text-disabled', ring: 'bg-text-disabled/40' },
  warning: { bg: 'bg-warning',  ring: 'bg-warning/40' },
  busy:    { bg: 'bg-danger',   ring: 'bg-danger/40' },
  idle:    { bg: 'bg-info',     ring: 'bg-info/40' },
};

const DOT_SIZE = { sm: 'w-1.5 h-1.5', md: 'w-2 h-2' };
const RING_SIZE = { sm: 'w-3 h-3', md: 'w-4 h-4' };

export function StatusIndicator({
  tone = 'online',
  label,
  pulse = false,
  size = 'md',
  className,
}: StatusIndicatorProps) {
  const cfg = TONE_MAP[tone];
  return (
    <span className={['inline-flex items-center gap-2', className].filter(Boolean).join(' ')}>
      <span className="relative inline-flex items-center justify-center">
        {pulse && (
          <span
            className={`absolute ${RING_SIZE[size]} ${cfg.ring} rounded-full animate-ping`}
            aria-hidden="true"
          />
        )}
        <span
          className={`relative ${DOT_SIZE[size]} ${cfg.bg} rounded-full`}
          aria-hidden="true"
        />
      </span>
      {label && <span className="text-xs text-text-secondary">{label}</span>}
    </span>
  );
}
